import { render } from "./MagentoSetupTuning.vue?vue&type=template&id=1fde9b32"
import script from "./MagentoSetupTuning.vue?vue&type=script&lang=js"
export * from "./MagentoSetupTuning.vue?vue&type=script&lang=js"

import "./MagentoSetupTuning.vue?vue&type=style&index=0&id=1fde9b32&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__